<template>
  <div class="login-container">
      <div class="form-side">
          <div class="login-box">
              <div class="logo">
                  <img src="@/assets/logo.png" alt="Logo Weeduc" />
              </div>
              
              <div class="form-header">
                  <h2>{{ $t('auth.activateTitle') }}</h2>
                  <p>{{ $t('auth.activateSubtitle') }}</p>
              </div>

              <form @submit.prevent="handleActivateAccount">
                  
                  <div class="form-group">
                      <label>{{ $t('auth.password') }}</label>
                      <div class="password-input">
                          <input 
                              :type="showPassword ? 'text' : 'password'"
                              v-model="password"
                              @input="validatePassword"
                              :placeholder="$t('auth.yourPasswordPlaceholder')"
                              required
                              minlength="8"
                              :class="{ 'error': passwordError }"
                          />
                          <span class="password-toggle" @click="togglePassword">
                              <fa :icon="showPassword ? 'eye-slash' : 'eye'" />
                          </span>
                      </div>
                      <div v-if="passwordError" class="field-error">
                          {{ passwordError }}
                      </div>
                      <div v-if="passwordValid && password" class="field-success">
                          ✓ {{ $t('auth.passwordValid') }}
                      </div>
                  </div>

                  <div class="form-group">
                      <label>{{ $t('auth.confirmPassword') }}</label>
                      <div class="password-input">
                          <input 
                              :type="showConfirmPassword ? 'text' : 'password'"
                              v-model="confirmPassword"
                              @input="validateConfirmPassword"
                              :placeholder="$t('auth.passwordRepeatPlaceholder')"
                              required
                              minlength="8"
                              :class="{ 'error': confirmPasswordError }"
                          />
                          <span class="password-toggle" @click="toggleConfirmPassword">
                              <fa :icon="showConfirmPassword ? 'eye-slash' : 'eye'" />
                          </span>
                      </div>
                      <div v-if="confirmPasswordError" class="field-error">
                          {{ confirmPasswordError }}
                      </div>
                      <div v-if="confirmPasswordValid && confirmPassword" class="field-success">
                          ✓ {{ $t('auth.passwordsMatch') }}
                      </div>
                  </div>

                  <div v-if="successMessage" class="success-message">
                      {{ successMessage }}
                  </div>

                  <div v-if="errorMessage" class="error-message">
                      {{ errorMessage }}
                  </div>

                  <div class="password-requirements">
                      <small>{{ $t('auth.passwordMinLength') }}</small>
                  </div>

                  <button 
                      type="submit" 
                      class="btn-login" 
                      :disabled="isLoading"
                  >
                      {{ isLoading ? $t('auth.activating') : $t('auth.activateAccount') }}
                  </button>

                  <div class="links">
                      <a href="/login">{{ $t('auth.backToLogin') }}</a>
                  </div>
              </form>
          </div>
      </div>
      <div class="banner-side">
          <div class="banner-content">
          </div>
      </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import apiPassword from '@/utils/password.js';

export default {
  data() {
      return {
          password: '',
          confirmPassword: '',
          token: '',
          showPassword: false,
          showConfirmPassword: false,
          successMessage: '',
          errorMessage: '',
          isLoading: false,
          typeSystemLocal: 1,
          baseUrl: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_URL_HOMOLOGATION : window.location.origin,
          passwordError: '',
          confirmPasswordError: '',
          passwordValid: false,
          confirmPasswordValid: false
      }
  },
  methods: {
      ...mapActions(['storeTypeSystem']),
      
      togglePassword() {
          this.showPassword = !this.showPassword;
      },
      
      toggleConfirmPassword() {
          this.showConfirmPassword = !this.showConfirmPassword;
      },
      
      validatePassword() {
          this.passwordError = '';
          this.passwordValid = false;
          
          if (this.password.length > 0 && this.password.length < 8) {
              this.passwordError = this.$t('auth.passwordTooShort', { current: this.password.length });
          } else if (this.password.length >= 8) {
              this.passwordValid = true;
          }
          
          // Revalidar confirmação de senha se já foi digitada
          if (this.confirmPassword) {
              this.validateConfirmPassword();
          }
      },
      
      validateConfirmPassword() {
          this.confirmPasswordError = '';
          this.confirmPasswordValid = false;
          
          if (this.confirmPassword.length > 0 && this.confirmPassword.length < 8) {
              this.confirmPasswordError = this.$t('auth.passwordTooShort', { current: this.confirmPassword.length });
          } else if (this.confirmPassword.length >= 8) {
              if (this.password && this.password !== this.confirmPassword) {
                  this.confirmPasswordError = this.$t('auth.passwordsMustMatch');
              } else if (this.password && this.password === this.confirmPassword) {
                  this.confirmPasswordValid = true;
              }
          }
      },
      async handleActivateAccount() {
          this.successMessage = '';
          this.errorMessage = '';
          
          // Validações
          if (!this.password || this.password.length < 8) {
              this.errorMessage = this.$t('auth.passwordMinLength');
              return;
          }
          
          if (this.password !== this.confirmPassword) {
              this.errorMessage = this.$t('auth.passwordsMustMatch');
              return;
          }
          
          this.isLoading = true;
          
          const obj = {
              "token": this.token,
              'password': this.password,
              'typeSystem': this.typeSystemLocal
          }
          
          try {
              const response = await apiPassword.resetPassowrd(obj);
              console.debug(response);
              this.successMessage = this.$t('auth.activateSuccessRedirect');
              
              // Redireciona para login após 2 segundos
              setTimeout(() => {
                  this.$router.push('/portal');
              }, 2000);

          } catch (error) {
              console.error(error);
              if (error.response && error.response.status === 400) {
                  this.errorMessage = this.$t('auth.invalidToken');
              } else if (error.response && error.response.status === 404) {
                  this.errorMessage = this.$t('auth.tokenNotFound');
              } else {
                  this.errorMessage = this.$t('auth.activateErrorRetry');
              }
          } finally {
              this.isLoading = false;
          }
      }
  },
  mounted() {
      this.token = this.$route.params.slug;
      
      // Verifica se o token existe
      if (!this.token) {
          this.errorMessage = this.$t('auth.activationTokenMissing');
      }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  min-height: 100vh;
}

.banner-side {
  flex: 1;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
}

.banner-content {
  position: relative;
  text-align: center;
  padding: 1.25rem;
}

.banner-content h1 {
  font-size: 2.5em;
  margin-bottom: 0.9375rem;
}

.form-side {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding: 2.5rem;
  width: 35%;
}

.login-box {
  width: 100%;
  max-width: 25rem;
  background: white;
  padding: 2.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.625rem rgba(0,0,0,0.1);
}

.logo {
  text-align: center;
  margin-bottom: 1.875rem;
}

.logo img {
  width: 12.5rem;
}

h2 {
  text-align: center;
  color: #272f3a;
  margin-bottom: 1.875rem;
}

.company-selection {
  text-align: center;
}

.company-selection h3 {
  color: #272f3a;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.company-selection p {
  color: #757e8a;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
  line-height: 1.4;
}

.form-group {
  margin-bottom: 2rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #757e8a;
  text-align: left;
}

input, select {
  width: 100%;
  padding: 1rem 3rem 1rem 1rem;
  border: 0.0625rem solid #ddd;
  border-radius: 0.25rem;
  font-size: 1rem;
  height: 3rem;
}

input::placeholder {
  font-size: 0.9rem;
}

input.error {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

input:focus {
  outline: none;
  border-color: #3db8bf;
  box-shadow: 0 0 0 0.2rem rgba(61, 184, 191, 0.25);
}

select {
  background-color: white;
  cursor: pointer;
}

.password-input {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.password-toggle {
  position: absolute;
  right: 1rem;
  cursor: pointer;
  color: #757e8a;
  font-size: 1.1rem;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);
}

.login-error {
  color: #d32f2f;
  background: #fff0f0;
  border: 1px solid #d32f2f;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 0.95em;
  margin: 15px;
  text-align: center;
}

.login-error a {
  color: #3db8bf;
  text-decoration: underline;
}

.success-message {
  color: #28a745;
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
  font-size: 0.95em;
  text-align: center;
}

.error-message {
  color: #d32f2f;
  background: #fff0f0;
  border: 1px solid #d32f2f;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
  font-size: 0.95em;
  text-align: center;
}

.password-requirements {
  margin-top: 5px;
  text-align: center;
}

.password-requirements small {
  color: #666;
  font-size: 12px;
}

.form-header {
  text-align: center;
  margin-bottom: 2rem;
}

.form-header h2 {
  color: #272f3a;
  margin-bottom: 0.5rem;
  font-size: 1.8rem;
}

.form-header p {
  color: #757e8a;
  font-size: 0.9rem;
  margin: 0;
}

.btn-login {
  width: 93%;
  padding: 1rem;
  background-color: #3db8bf;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  margin: 1.5rem 10px;
  height: 3.5rem;
}

.btn-login:hover {
  background-color: #2a9ca3;
}

.btn-login:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.btn-back {
  width: 40%;
  padding: 0.75rem;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-right: 10px;
}

.btn-back:hover {
  background-color: #5a6268;
}

.company-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5rem;
}

.company-actions .btn-login {
  width: 55%;
  margin: 0;
}

.links {
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: end;
  padding: 0px 13px;
}

.links a {
  color: #3db8bf;
  text-decoration: none;
  font-size: 12px;
}

.links a:hover {
  color: #333;
}

.field-error {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  min-height: 1.5rem;
}

.field-success {
  color: #28a745;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  font-weight: 500;
  min-height: 1.5rem;
}

@media (max-width: 48rem) {
  .login-container {
      flex-direction: column;
  }
  
  .banner-side {
      display: none;
  }
  
  .form-side {
      padding: 1.25rem;
  }
  
  .login-box {
      padding: 1.25rem;
  }

  .company-actions {
      flex-direction: column;
      gap: 10px;
  }

  .company-actions .btn-login,
  .btn-back {
      width: 100%;
      margin: 0;
  }
}
.banner-side {
  background-image: url('@/assets/portal/Login-weeduc.png');
  background-size: cover;
  background-position: center;
  background-color: none!important;
}
@media (max-width: 768px) {
  .form-side {
      width: 100%;
      height: 100vh;
  }
}
</style>
